import axios from '@/axios';
import getDecrypt, { getEncrypt } from '../../../utils/permission';

const actions = {
  async lrList({ commit }) {
    try {
      commit('SET_LR_LOADING', true);
      const result = await axios('lorry_receipt');
      commit('SET_LR', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_LR_LOADING', false);
    }
  },
  async uploadCertification({ commit }, data) {
    try {
      commit('setUploading', true);
      const result = await axios.post('/attachment', data, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result.data;
    } catch (error) {
      commit('setUploading', false);
      return error;
    } finally {
      commit('setUploading', false);
    }
  },
  async updateCertification({ commit }, params) {
    try {
      commit('setUploading', true);
      const result = await axios.put('/transporter/certificate', { data: params.data });
      return result.data;
    } catch (error) {
      commit('setUploading', false);
      return error;
    } finally {
      commit('setUploading', false);
    }
  },
  async getCertifications({ commit }) {
    try {
      commit('SET_LOADING', true);
      const result = await axios('transporter/certificate/');
      if (result && result.data.fssai) {
        commit('SET_CERTITFICATION', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async updateLR({ commit }, data) {
    try {
      commit('SET_LR_LOADING', true);
      const result = await axios.put('lorry_receipt/save', data);
      commit('SET_LR', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_LR_LOADING', false);
    }
  },
  async deactivateLr({ commit }, data) {
    try {
      commit('SET_LR_LOADING', true);
      const result = await axios.put('lorry_receipt/deactivate', data);
      commit('SET_LR', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_LR_LOADING', false);
    }
  },
  async getCentralHo() {
    try {
      const result = await axios.get('settings/central_ho');
      return result;
    } catch (err) {
      return err;
    }
  },
  async getRoles({ commit, rootGetters }) {
    try {
      const result = await axios.get('/transporter/role_permissions');
      if (result && result.data) {
        const secret = rootGetters['app/currentUser'].id;
        const permissionList = getDecrypt(result.data.permissionList, secret);
        const rolePermissions = result.data && result.data.rolePermissions.map(item => ({
          ...item,
          permissions: getDecrypt(item.enabledPermissions, secret),
        }));
        commit('SET_CONFIGURATION_ROLES', { permissionList, rolePermissions });
      }
      return result.data;
    } catch (err) {
      return err;
    }
  },
  async updateRolePermission(_, { role, permissions }) {
    try {
      const currentUser = _.rootGetters['app/currentUser'];
      const payload = {
        role,
        permissions: getEncrypt(permissions, currentUser.id),
      };
      return await axios.post('/transporter/role_permissions', payload);
    } catch (err) {
      return err;
    }
  },

};

export default actions;
